import { useMailboxTopics } from "./useMailboxTopics";

const initials = (s) => (s || "?").split(/[^\p{L}\p{N}]+/u).filter(Boolean).slice(0, 2).map((w) => w[0]).join("").toUpperCase() || "?";
const shortDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const today = new Date();
  if (d.toDateString() === today.toDateString()) return d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" });
  return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", ...(d.getFullYear() !== today.getFullYear() ? { year: "2-digit" } : {}) });
};

export function MailListItem({ email: e, active, onSelect }) {
  const topics = useMailboxTopics();
  const topic = topics.find((t) => t.id === e.topic_id);
  const sent = e.folder === "sent";
  const who = sent ? `An ${(e.to || []).map((r) => r.name || r.email).join(", ")}` : e.from_name || e.from_email;
  const unread = !sent && !e.work_state && e.status !== "ignored";

  return (
    <button type="button" onClick={() => onSelect(e)} aria-current={active}
      className={`w-full text-left flex gap-3 p-3 border-l-4 transition-colors ${active ? "bg-[#F0F4F9] border-l-[#1E3A5F]" : "border-l-transparent hover:bg-slate-50"}`}
      data-testid={`mail-row-${e.id}`}>
      <div className={`w-9 h-9 rounded-full flex items-center justify-center shrink-0 text-xs font-semibold ${sent ? "bg-sky-50 text-sky-700" : "bg-[#FFF5EC] text-[#C95F06]"}`}>{initials(sent ? e.to?.[0]?.name || e.to?.[0]?.email : e.from_name || e.from_email)}</div>
      <div className="min-w-0 flex-1">
        <div className="flex items-baseline gap-2">
          <span className={`truncate text-sm ${unread ? "font-semibold text-foreground" : "text-muted-foreground"}`}>{who}</span>
          <span className="ml-auto text-[11px] text-muted-foreground shrink-0 tabular-nums">{shortDate(e.received_at)}</span>
        </div>
        <p className={`truncate text-sm ${unread ? "font-medium text-foreground" : "text-slate-700"}`}>{e.subject}</p>
        {e.excerpt && <p className="truncate text-xs text-muted-foreground">{e.excerpt}</p>}
        <div className="flex items-center gap-2 mt-1 text-[11px] text-muted-foreground min-w-0">
          {topic && <span className="inline-flex items-center gap-1 shrink-0"><span className="w-1.5 h-1.5 rounded-full" style={{ background: topic.color || "#94A3B8" }} />{topic.name}</span>}
          {e.status === "assigned" && e.target_name && <span className="truncate">· {e.target_name}</span>}
          {e.status === "open" && <span className="shrink-0 text-amber-700">· ohne Zuordnung</span>}
          {e.work_state && <span className={`ml-auto shrink-0 font-medium ${e.work_state === "done" ? "text-emerald-700" : "text-sky-700"}`}>{e.work_state === "done" ? "Erledigt" : "In Bearbeitung"}</span>}
        </div>
      </div>
    </button>
  );
}
